/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/ManagedIdentity/AppRegistrationMIComponent" />

import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IAzurRMComponentProps } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMAutoServicePrincipalEndpointEditorComponent";
import { GenericAuthEndpointDetailsComponent } from "../Generic/GenericAuthEndpointDetailsComponent";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { IIdenityTypeState, IdentityTypeStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/IdentityTypeStore";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { IdentityTypePicker } from "../IdentityType/IdentityTypePicker";
import { IdentityType } from "../../Contracts/IdentityType";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { StoreManager } from "DistributedTask/Flux/StoreManager";

export class AppRegistrationMIComponent extends VssComponent<IAzurRMComponentProps, IIdenityTypeState> {

    private readonly _identityTypeStore: IdentityTypeStore;
    private _endpointsEditorActionsCreator: EndpointsEditorActionsCreator;

    constructor(props: IAzurRMComponentProps, context: IVssComponentContext) {
        super(props, context);

        this._identityTypeStore = StoreManager.GetStore<IdentityTypeStore>(IdentityTypeStore, ActionsCreatorInstanceIds.IdentityTypeStoreInstanceId, context.pageContext);
        
        this._endpointsEditorActionsCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(
            EndpointsEditorActionsCreator,
            ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId
        );

        this.state = {
            identityType: this._identityTypeStore.getState().identityType
        };
    }

    public render(): React.ReactNode {
        const identityType = this._identityTypeStore.getState().identityType;
        return (
            <React.Fragment>
                {!this.props.isUpdateForm && <IdentityTypePicker onSelect={this._onIdentityTypeSelected} value={identityType} />}
                <div>
                    <GenericAuthEndpointDetailsComponent {...this.props} />
                </div>
            </React.Fragment>
        );
    }

    private _onIdentityTypeSelected = (identityType: IdentityType): void => {
        this._endpointsEditorActionsCreator.setServiceEndpointIdentityType(identityType);
    }
}
